import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import moment from "moment"; 
import history from "../../../../../routes/history";
import { useDispatch, useSelector } from 'react-redux';
import { candidateDetailSuccess } from '../../../../../redux/actions';
import CandidateSignupButton from "../CandidateBackNext/CandidateSignupButton";
import ProgressBar from "../../../../../components/ProgressBar/ProgressBar";
import errorIcon from "../../../../../assets/img/ci_warning.png";
import "./StartDate.css";

function StartDate() {
  const dispatch = useDispatch();
  const getInputValues = useSelector((state) => state.candidateReducer.candidateDetails);

  const [selectedDate, setSelectedDate] = useState(
    getInputValues?.startDate ? moment(getInputValues.startDate, "YYYY-MM-DD") : null
  );
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (getInputValues?.startDate) {
      setSelectedDate(moment(getInputValues.startDate, "YYYY-MM-DD"));
    }
  }, [getInputValues]);

  const backFunction = () => {
    history.push('/candidate-salary');
  };

  const nextFunction = () => {
    if (!selectedDate) {
      setShowError(true);
    } else {
      setShowError(false);
      dispatch(candidateDetailSuccess({ ...getInputValues, startDate: selectedDate.format("YYYY-MM-DD") }));
      history.push('/message-candidate');
    }
  };

  const skipFunction = () => {
    setSelectedDate(null); 
    dispatch(candidateDetailSuccess({ ...getInputValues, startDate: null })); 
    history.push('/message-candidate');
  };

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar heading={"Create candidate’s skill listing"} percent={90}/>
        <div className="email-text">
          Desired start date
          <div className="email-mandatory">(Optional)</div>
        </div>
        <div className="gig-sub">
          Provide the earliest date the candidate is available to begin
        </div>
        <div>
          <DatePicker
            placeholder="MM DD,YYYY" 
            className={`datePicker ${showError ? "error-block" : ""}`}
            format="MMMM DD, YYYY"
            value={selectedDate || null}
            disabledDate={(date) =>
              date && date.isBefore(moment().startOf("day"))
            }
            onChange={(date) => {
              setSelectedDate(date);
              setShowError(false);
              dispatch(
                candidateDetailSuccess({
                  ...getInputValues,
                  startDate: date ? date.format("YYYY-MM-DD") : null,
                })
              );
            }}
            inputReadOnly
          />
        </div>
        {showError && (
          <div className="error-msg-content">
            <img src={errorIcon} alt="Error icon" />
            <span className="error-text">Please enter your start date to continue</span>
          </div>
        )}
        <div style={{ paddingTop: "25%" }}>
          <CandidateSignupButton
            nextFunction={nextFunction}
            backFunction={backFunction}
            skipFunction={skipFunction}
          />
        </div>
      </div>
    </div>
  );
}

export default StartDate;
